import { get, post, put } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export const getChangeOrders = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.CHANGE_ORDERS.LIST(projectId));

export const getGcChangeOrders = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.CHANGE_ORDERS.GC_LIST(projectId));

export const getChangeOrder = (
  projectId: string,
  id: string,
): Promise<ApiResponse> => get(ENDPOINTS.CHANGE_ORDERS.DETAIL(projectId, id));

export const createChangeOrder = (
  projectId: string,
  data: unknown,
): Promise<ApiResponse> =>
  post(ENDPOINTS.CHANGE_ORDERS.CREATE(projectId), data);

export const updateChangeOrder = (
  projectId: string,
  id: string,
  data: unknown,
): Promise<ApiResponse> =>
  put(ENDPOINTS.CHANGE_ORDERS.UPDATE(projectId, id), data);

export const approveChangeOrder = (
  projectId: string,
  id: string,
  data: unknown,
): Promise<ApiResponse> =>
  post(ENDPOINTS.CHANGE_ORDERS.APPROVE(projectId, id), data);

export const rejectChangeOrder = (
  projectId: string,
  id: string,
  data: unknown,
): Promise<ApiResponse> =>
  post(ENDPOINTS.CHANGE_ORDERS.REJECT(projectId, id), data);
